/** Make a promise throw an error if it doesn't resolve before a timeout. */
export function timeoutWithError<T>(
  promise: Promise<T>,
  timeoutMs: number,
  error: Error | (() => Error)
): Promise<T> {
  let timeoutPid: ReturnType<typeof setTimeout>;
  const timeout = new Promise<T>((_, reject) => {
    timeoutPid = setTimeout(() => reject(typeof error === 'function' ? error() : error), timeoutMs);
  });
  return Promise.race([promise, timeout]).finally(() => {
    timeoutPid && clearTimeout(timeoutPid);
  });
}

/** Make a promise return a default value if it doesn't resolve before a timeout. */
export function timeoutWithDefault<T>(
  promise: Promise<T>,
  timeoutMs: number,
  defaultValue: T
): Promise<T> {
  let timeoutPid: ReturnType<typeof setTimeout>;
  const timeout = new Promise<T>(resolve => {
    timeoutPid = setTimeout(() => resolve(defaultValue), timeoutMs);
  });
  return Promise.race([promise, timeout]).finally(() => {
    timeoutPid && clearTimeout(timeoutPid);
  });
}
